<script>
import RexButton from '@/rex-components/rex-button.vue';
import getEnv from '@/utils/env';
import { mapState } from 'vuex';

const LOG_MONITOR_DOCS_URL =
  getEnv('VUE_APP_LOG_MONITOR_DOCS_URL') ||
  'https://qa-docs.133.237.79.36.sslip.io/observability/docs/overview/';

const ANALYTICS_DOCS_URL =
  getEnv('VUE_APP_ANALYTICS_DOCS_URL') ||
  'https://qa-docs.133.237.79.36.sslip.io/observability/docs/overview/';

export default {
  components: {
    RexButton,
  },
  computed: {
    ...mapState('logState/logCommonState', ['isADType']),
    getNoDataLabel() {
      return this.isADType
        ? this.$t('analytics.noDataFound')
        : this.$t('log.noLogsFound');
    },
    getDocToTransferMsg() {
      return this.isADType
        ? this.$t('analytics.theDocsToTransferTheData')
        : this.$t('log.theDocsToTransferTheLogs');
    },
  },
  methods: {
    openPage() {
      const urlToOpen = this.isADType
        ? ANALYTICS_DOCS_URL
        : LOG_MONITOR_DOCS_URL;
      window.open(urlToOpen, '_blank');
    },
  },
};
</script>

<template>
  <div :class="$style.infoBox">
    <div>
      <BaseIcon name="noData" />
      <div :class="$style.titleMsg">
        {{ getNoDataLabel }}
      </div>
      <div>{{ $t('log.followTheInstructionsOn') }}</div>
      <div :class="$style.detailsMsg">
        {{ getDocToTransferMsg }}
      </div>
      <RexButton
        variant="primary"
        id="log-view-doc-or-contact-sales-btn"
        :styling="{ width: '12rem' }"
        @onClick="openPage"
      >
        {{ $t('log.viewDocs') }}
      </RexButton>
    </div>
  </div>
</template>

<style lang="scss" module>
.infoBox {
  @include flex-center;
  width: 100%;
  height: 88vh;
}
.titleMsg {
  @include heading-text;
  margin-top: 1.438rem;
}
.detailsMsg {
  margin-bottom: 1.438rem;
}
</style>
